import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import React from "react";
import { StyledContainerRow } from "../../../components/ModalComponents/StyledModalComponents";
import ContainedButton from "../../../components/Buttons/ContainedButton";
import EvrRatioModal from "./EvrRatioModal";
import styled from "styled-components";

import svg_background from "../../../assets/images/Path_7821.png";

const EvrRatioHeightAndWeight = ({ showFinalScore }) => {
  const { t } = useTranslation();

  return (
    <StyledContainerRow className="row w-100">
      <div className="col-5 col-md-1 col-lg-5"></div>
      {/*<EvrRatioModal showFinalScore={showFinalScore}></EvrRatioModal>*/}
      <div className="col-2"></div>
    </StyledContainerRow>
  );
};

export default EvrRatioHeightAndWeight;
